// Shared style objects for the four auth pages (Sign In, Forgot Password,
// Reset Password, Sign Up). Keeping these in one place ensures the pages stay
// visually consistent. The auth brand color (#1F4E55) is intentionally kept
// separate from the app tokens.

// External field label rendered above each input (the SignIn pattern).
export const labelSx = {
  fontSize: "0.8rem",
  fontWeight: 600,
  color: "#334155",
  mb: 0.75,
};

// Default-height outlined input with slightly rounded corners.
export const fieldSx = {
  "& .MuiOutlinedInput-root": { borderRadius: 2 },
};

// Primary call-to-action button shared across the auth pages.
export const primaryBtnSx = {
  mt: 3,
  py: 1.25,
  borderRadius: 2,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.95rem",
  bgcolor: "#1F4E55",
  color: "#fff",
  boxShadow: "none",
  "&:hover": { bgcolor: "#173c42", boxShadow: "none", transform: "none" },
  "&.Mui-disabled": { bgcolor: "rgba(0,0,0,0.12)", color: "rgba(0,0,0,0.4)" },
};
